import { ChangeDetectionStrategy, Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { SINInputComponent } from '../../../form-components/sin-input/sin-input.component';

@Component({
  selector: 'app-review-sin-input',
  templateUrl: './review-sin-input.component.html',
  styleUrls: ['./review-sin-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ReviewSinInputComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReviewSinInputComponent extends SINInputComponent {
  @Input() canRevealSIN: boolean | null = true;

  public showingSIN: boolean = true;

  public override toggleShowHide(): void {
    if (!this.canRevealSIN) return;
    this.showingSIN = !this.showingSIN;
    this.hiddenSINElement.nativeElement.innerHTML = this.getHiddenSINString();
    this.showMaskedSIN = !this.maskWhileTyping && !this.showingSIN && !!this.value;
  }
}
